import { useQuery } from '@tanstack/react-query';
import { useAuthActions } from '../../../core/context/auth';
import { ApiService } from '../../../core/services';
import { Group, Role } from '../../admin/models';

export interface User {
  id: number;
  name: string;
  username: string;
  email: string;
  password?: string;
  license: string;
  access: string;
  groups?: Array<number>;
  roles?: Array<Role>;
  clients: Array<Group>;
  terms_ack: boolean;
  first_login: boolean;
}

interface Profile {
  user: User;
}

export const ACCOUNT_QUERY_KEYS = {
  ME: 'me',
} as const;

type UseGetProfileProps = {
  enabled: boolean;
};

export const useGetProfile = ({ enabled }: UseGetProfileProps) => {
  const { setProfile } = useAuthActions();

  return useQuery([ACCOUNT_QUERY_KEYS.ME], () => ApiService.get<Profile>('me/').then((response) => response.data), {
    enabled,
    onSuccess: ({ user }) => {
      setProfile(
        user.id,
        user.username,
        user.email,
        user.name,
        user.clients,
        user.terms_ack,
        user.first_login,
        user.license
      );
    },
  });
};
